//
import PchPaymentConditionModel from '@/models/Purchase/PchPaymentCondition'
import { RFormFields } from '@/components/reusable_components/next'

//
export default RFormFields
  .from([
    {
      name: 'title_general',
      type: 'card-title-section',
      flex: {
        xs12: true,
      },
      props: {
        title: 'Datos generales',
      },
    },
    {
      name: 'rut',
      type: 'rut-field',
      flex: {
        sm6: true,
        lg3: true,
      },
      props: {
        label: 'Rut',
      },
    },
    {
      name: 'alias_name',
      type: 'text-field',
      flex: {
        sm6: true,
        lg4: true,
      },
      props: {
        label: 'Nombre fantasía',
      },
    },
    {
      name: 'business_name',
      type: 'text-field',
      flex: {
        sm6: true,
        lg5: true,
      },
      props: {
        label: 'Razón social',
      },
    },
    {
      name: 'core_business',
      type: 'text-field',
      flex: {
        sm6: true,
        lg6: true,
      },
      props: {
        label: 'Giro',
      },
    },
    {
      name: 'email_collection',
      type: 'text-field',
      flex: {
        sm6: true,
        lg6: true,
      },
      props: {
        label: 'Correo electrónico',
      },
    },
    {
      name: 'branch_offices',
      type: 'table-field',
      flex: {
        'd-grid': true,
        xs12: true,
      },
      props: {
        headers: [
          {
            text: 'ciudad',
            value: 'city',
          },
          {
            text: 'dirección',
            value: 'address',
          },
          {
            text: 'correo electrónico',
            value: 'email',
          },
          {
            text: 'teléfono',
            value: 'phone',
          },
          {
            text: 'vendedor',
            value: ({ sl_customer_ground_seller }) => {
              return sl_customer_ground_seller ? sl_customer_ground_seller.sl_ground_seller.hr_employee.name_case : '-'
            },
          },
        ],
        noRefresh: true,
        toolbarTitle: 'Sucursales',
      },
    },  
    {
      name: 'title_discount',
      type: 'card-title-section',
      flex: {
        xs12: true,
      },
      props: {
        title: 'Descuento y condicion de pago',
      },
    },
    {
      name: 'discount',
      type: 'float-field',
      props: {
        label: 'Descuento autorizado',
        suffix: '%',
      },
    },
    {
      name: 'pch_payment_condition_id',
      type: 'autocomplete-model',
      props: {
        itemText: 'type',
        itemValue: 'id',
        itemKey: 'id',
        label: 'Condicion de pago',
        model: PchPaymentConditionModel,
        noAsyncSearch: true,
        noObject: true,
        paramSearch: 'type',
      },
    },
    {
      name: 'blocked_sales_str',
      type: 'text-field',
      props: {
        label: 'Estado',
        readonly: true,
      },
    },
    {
      name: 'flag_send_debt_email_str',
      type: 'text-field',
      props: {
        label: 'Cobranza',
        readonly: true,
      },
    },
    /**{
      name: 'title_credit',
      type: 'card-title-section',
      flex: {
        xs12: true,
      },
      props: {
        title: 'Cupo y cobranza',
      },
    },
    {
      name: 'max_customer_credit_amount',
      type: 'currency-field',
      props: {
        label: 'Cupo',
      },
    },*/

    /**
     * { item_description }
     */

    {
      name: 'branch_offices_to_credit',
      type: 'table-field',
      flex: {
        'd-grid': true,
        xs12: true,
      },
      props: {
        headers: [
          {
            text: 'dirección',
            value: 'address',
            width: '50%',
          },
          {
            text: 'cupo',
            value: 'max_customer_credit',
            format: 'currency',
            input: {
              type: 'currency-field',
              reverse: true,
            },
            width: '20%',
          },
          {
            text: 'holgura',
            value: 'slack_customer_credit',
            format: 'percentage',
            input: {
              type: 'float-field',
              reverse: true,
              prefix: '%',
            },
            width: '20%',
          },
        ],
        noActions: false,
        noRemove: true,
        noDetail: true,
        noRefresh: true,
        toolbarTitle: 'Cupo maximo por sucursal',
      },
      slots: {
        actions: 'branch-offices-to-credit-actions'
      },
    },  
  ])
